import { useState } from "react";
import { ClosingChecklistListTypeEnum } from "../../../_common/enum/closingChecklistListType.enum";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { accountService } from "../../../_services/accounts.service";
import { TicketClosingChecklistListAgent } from "./ticket-closingChecklistListAgent";

export function TicketClosingChecklistAgentPanel(params: { paymentDate?: string, invoiceNumber?: string }) { 

    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            <StandardPanel

                title={(accountService.isAdmin ? "Closing Checklist Agent" : "Closing Checklist")}
                loading={isLoading}>

                <TicketClosingChecklistListAgent paymentDate={params.paymentDate} invoiceNumber={params.invoiceNumber}  closingChecklistListTypeId={ClosingChecklistListTypeEnum.Agent} />
            </StandardPanel>
          
        </>
    );

}
